import { useEffect, useState } from 'react'
import styles from './PublicPlaceCard.module.css'
import PlatformCardShortInformation from '../../components/PlatformCardShortInformation/PlatformCardShortInformation'
import PlatformCardFilesBlock from '../../components/PlatformCardFilesBlock/PlatformCardFilesBlock'
import PublicBookingForm from '../../components/PublicBookingForm/PublicBookingForm'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { getCurrentPublicPlaces } from '../../redux/actions/placesAction'
import Loader from '../../components/UI/Loader/Loader'
import noImage from '../../assets/img/no-image.jpg'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import NewSlider from '../NewSlider/NewSlider'

const PublicPlaceCard = () => {
  const navigate = useNavigate()

  let { isLoading, currentPlace } = useAppSelector((state) => state.places)

  const { id } = useParams<{ id: string }>()

  const dispatch = useAppDispatch()

  const dummyData = (imagesArr: string[]) => {
    return imagesArr.map((image, index) => {
      return { id: index, src: `${process.env.REACT_APP_BASE_URL_IMAGES}${image}` }
    })
  }

  const imagesFull = dummyData(currentPlace.images)

  const onRedirectBack = () => {
    navigate(-1)
  }

  useEffect(() => {
    dispatch(getCurrentPublicPlaces({ placeId: id }))
  }, [id, dispatch])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.platformCard}>
      <HeaderForCard onRedirectHandler={onRedirectBack} title={currentPlace.name} />
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Основная информация</h2>
        </div>

        <div className={styles.wrapper}>
          <div>
            {imagesFull.length !== 0 ? (
              <div>
                <NewSlider slides={imagesFull} />
              </div>
            ) : (
              <div className={styles.slider}>
                <img className={styles.noImage} src={noImage} alt='noImage' />
              </div>
            )}
            <div className={styles.content}>
              <div className={styles.leftBlock}>
                <PlatformCardShortInformation platformData={currentPlace} publicPlace />
                {currentPlace.files.length !== 0 && (
                  <PlatformCardFilesBlock platformData={currentPlace} />
                )}
              </div>
            </div>
          </div>
          <div className={styles.rightBlock}>
            <PublicBookingForm
              onRedirectBack={onRedirectBack}
              platformData={currentPlace}
              platformCity={currentPlace.city}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PublicPlaceCard
